module.exports = __webpack_public_path__ + "media/images/icon-haccps-confirmation-blue-1bdb2d355806e9659c4d7ec30a1d7211.svg";